export default [
  {
    name: 'note',
    displayText: 'note',
    icon: 'sticky-note'
  },
  {
    name: 'text',
    displayText: 'field',
    icon: 'window-maximize'
  },
  {
    name: 'boolean',
    displayText: 'checkbox',
    icon: 'check-square'
  },
  // {
  //   name: 'number',
  //   icon: 'sort-numeric-up-alt'
  // },
  {
    name: 'markdown',
    displayText: 'document',
    icon: 'file'
  },
  {
    name: 'folder',
    displayText: 'folder',
    icon: 'folder'
  },
  {
    name: 'audio',
    displayText: 'audio',
    icon: 'microphone'
  },
  {
    name: 'command',
    displayText: 'command',
    icon: 'terminal'
  }
  // {
  //   name: 'date',
  //   icon: 'calendar-day'
  // }
]
